export const enModals = {
  redirect_message: 'When you click on the continue button you will connect to another website which we do not own or operate.'
}
